module.exports = {"TXTWCL_Convert_Funds":{"id":"TXTWCL_Convert_Funds","defaultMessage":"Guthaben konvertieren","track":"Convert Funds"}}